import { FC, useCallback } from "react";

import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { normalizedCostWidgetSetupDateSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupDateSelector";
import { normalizedCostWidgetSetupDataChangeThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/setup-change/normalizedCostWidgetSetupDataChangeThunk";
import { DateLabelNullable } from "@/services/cloudchipr.api";
import { NormalizedCostWidgetDateRangeSelect } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/NormalizedCostWidgetDateRangeSelect";

export const NormalizedCostWidgetSetupDateRangeSelect: FC = () => {
  const dispatch = useAppDispatch();
  const value =
    useAppSelector(normalizedCostWidgetSetupDateSelector)?.label ??
    "last_twelve_months";

  const dateRangeChangeHandler = useCallback(
    (label: DateLabelNullable) => {
      if (!label) {
        return;
      }

      dispatch(
        normalizedCostWidgetSetupDataChangeThunk({
          dates: {
            label: label as DateLabelNullable,
          },
        }),
      );
    },
    [dispatch],
  );

  return (
    <NormalizedCostWidgetDateRangeSelect
      dateLabel={value}
      onChange={dateRangeChangeHandler}
    />
  );
};
